import { Box } from '@mui/material';

import {
    type ReportPropertiesDisplaySource,
    getPropertiesTooltip,
} from 'shared/lib/reports';

interface ReportPropertiesTooltipProps {
    dto?: ReportPropertiesDisplaySource;
}

export const ReportPropertiesTooltip = ({
    dto,
}: ReportPropertiesTooltipProps) => {
    if (!dto) {
        return null;
    }

    const content = getPropertiesTooltip(dto);

    if (!content) {
        return null;
    }

    return (
        <Box
            sx={{
                maxHeight: 260,
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                paddingRight: 0.5,
            }}
        >
            {content}
        </Box>
    );
};
